import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans, useTranslation } from 'react-i18next';

const SchoolAdminPrimarySchool = () => {
    const { t } = useTranslation(['help']);

    return (
        <div>
            <h1>{t('schoolAdminPrimarySchool.title', { ns: 'help' })}</h1>
            <p>{t('schoolAdminPrimarySchool.text1', { ns: 'help' })}</p>
            <h3>{t('schoolAdminPrimarySchool.useCase.title', { ns: 'help' })}</h3>
            <p>{t('schoolAdminPrimarySchool.useCase.text1', { ns: 'help' })}</p>
            <h3>{t('schoolAdminPrimarySchool.choice.title', { ns: 'help' })}</h3>
            <p>{t('schoolAdminPrimarySchool.choice.text1', { ns: 'help' })}</p>
            <h3>{t('schoolAdminPrimarySchool.clear.title', { ns: 'help' })}</h3>
            <p>{t('schoolAdminPrimarySchool.clear.text1', { ns: 'help' })}</p>
            <h3>{t('schoolAdminPrimarySchool.symbolExplanation.title', { ns: 'help' })}</h3>
            <p>
                <FontAwesomeIcon key='grey' className="me-2" color="grey" icon="check" /> {t('schoolAdminPrimarySchool.symbolExplanation.calculated', { ns: 'help' })}<br/>
                <FontAwesomeIcon key='green' className="me-2" color="orange" icon="crown" /> {t('schoolAdminPrimarySchool.symbolExplanation.chosen', { ns: 'help' })}
            </p>
        </div>
    )
}

export default SchoolAdminPrimarySchool;
